// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appName: 'BP',
  appIconColor: '#40E0D0',
  mydocmaConfig : {
    apiUrl: 'https://api-test.edr-software.com/mydocma',
    clientUrl: 'https://mydocma-test.edr-software.com',
    appId: '68d07e2f-592f-47d8-a109-6532ebf4831e'
  },
  authConfig : {
    clientId: 'mydocma.BP', // PIX
    scope: 'offline_access iam ap',
    oidc: false,
    issuer: 'https://api-test.edr-software.com/mydocma',
    redirectUri: 'https://bp-test.edr-software.com/auth/callback',
    requireHttps: false,
    responseType: 'code',
    ignoredUrls: [
      '//assets.edr-software.com',
      'https://assets.edr-software.com',
     ],
    logoutUrl: 'https://mydocma-test.edr-software.com/account/logout',
    postLogoutRedirectUri: ''

  },
  bpConfig: {
    apiUrl: 'https://node-test.edr-software.com/bp/'
  },
  webSocketConfig: {​​​​​​​​
  serverUrl:'wss://node-test.edr-software.com:443/websocket/',
  reconnectInterval:20000,
  /// -1 = infinity
  /// 0 = no reconnect
  /// >0 = attemmpts number
  reconnectAttempts: -1,
  heartbeatInterval:20000,

    }​​​​​​​​,
  taskConfig: {​​​​​​​​
  apiUrl:'https://node-test.edr-software.com/tasks-api'
  }​​​​​​​​
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
